import { render, staticRenderFns } from "./Health.vue?vue&type=template&id=5a0df0de&scoped=true&"
import script from "./Health.vue?vue&type=script&lang=js&"
export * from "./Health.vue?vue&type=script&lang=js&"
import style0 from "./Health.vue?vue&type=style&index=0&id=5a0df0de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0df0de",
  null
  
)

export default component.exports